import { HttpClientModule } from '@angular/common/http';
import { ApolloModule } from 'apollo-angular';
import { HttpLinkModule } from 'apollo-angular-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { from } from 'apollo-link';
import { setContext } from 'apollo-link-context';
import { onError } from 'apollo-link-error';
import { environment } from '../../../environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "apollo-angular";
import * as i2 from "apollo-angular-link-http";
import * as i3 from "@savvaslearning/lst-auth";
import * as i4 from "../../realize-overview/services/realize-overview/realize-overview.service";
export class GraphqlModule {
    constructor(apollo, httpLink, lstUserService, realizeOverviewService) {
        this.apollo = apollo;
        this.httpLink = httpLink;
        this.lstUserService = lstUserService;
        this.realizeOverviewService = realizeOverviewService;
        apollo.create({
            link: from([this.authMiddleware(), this.errorAfterware(), this.http()]),
            cache: new InMemoryCache(),
            defaultOptions: {
                watchQuery: {
                    fetchPolicy: 'no-cache',
                    errorPolicy: 'all',
                },
                mutate: {
                    fetchPolicy: 'no-cache',
                    errorPolicy: 'all',
                },
                query: {
                    fetchPolicy: 'no-cache',
                    errorPolicy: 'all',
                },
            },
        }, environment.apolloNameSpace);
    }
    authMiddleware() {
        return setContext((_, { headers }) => {
            // get the rbs token from session storage if it exists
            const rbsToken = this.lstUserService.getRbsToken();
            // return the headers to the context so httpLink can read them
            return {
                headers: Object.assign(Object.assign({}, headers), { authorization: rbsToken ? `Bearer ${rbsToken}` : '', userId: this.lstUserService.getCurrentUserId(), organizationIds: this.realizeOverviewService.getOrganizationIds }),
            };
        });
    }
    http() {
        const uri = `${environment.backendForFrontend.url}${environment.backendForFrontend.apiPath}`;
        return this.httpLink.create({ uri });
    }
    errorAfterware() {
        return onError(({ graphQLErrors, networkError }) => {
            if (graphQLErrors) {
                graphQLErrors.forEach(({ message, locations, path, extensions }) => {
                    console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`);
                });
            }
            if (networkError) {
                console.log(`[Network error]: ${networkError}`);
            }
        });
    }
}
GraphqlModule.ɵfac = function GraphqlModule_Factory(t) { return new (t || GraphqlModule)(i0.ɵɵinject(i1.Apollo), i0.ɵɵinject(i2.HttpLink), i0.ɵɵinject(i3.LstUserService), i0.ɵɵinject(i4.RealizeOverviewService)); };
GraphqlModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: GraphqlModule });
GraphqlModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [HttpClientModule, ApolloModule, HttpLinkModule] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(GraphqlModule, { exports: [HttpClientModule, ApolloModule, HttpLinkModule] }); })();
